import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { LayoutMetadataBase } from '../../../../model/dyn-form/form-metadata/layout/layout-metadata.model';
import { RepeatLayoutMetadataBase } from '../../../../model/dyn-form/form-metadata/layout/repeat-layout-metadata.model';
import { CommonModule } from '@angular/common';
import { DynamicViewRowLayoutComponent } from '../dynamic-view-row-layout/dynamic-view-row-layout.component';
import { HasShowHideLogic } from '../../../../model/dyn-form/form-metadata/logic/has-show-hide-logic.model';
import { ItemMetadataBase } from '../../../../model/dyn-form/form-metadata/item/item-metadata.model';
import { ItemTypeMetadata } from '../../../../model/dyn-form/form-metadata/item-type-metadata.enum';
import { LayoutTypeMetadata } from '../../../../model/dyn-form/form-metadata/layout-type-metadata.enum';
import { RowLayoutMetadataBase } from '../../../../model/dyn-form/form-metadata/layout/row-layout.metadata.model';
import { ShowHideLogicMetadataBase } from '../../../../model/dyn-form/form-metadata/logic/show-hide-logic-metadata.model';

@Component({
    selector: 'app-dynamic-view-repeat-layout',
    templateUrl: './dynamic-view-repeat-layout.component.html',
    styleUrls: ['./dynamic-view-repeat-layout.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        DynamicViewRowLayoutComponent
    ]
})
export class DynamicViewRepeatLayoutComponent implements OnInit {


    @Input()
    set layout(p: LayoutMetadataBase) {
        this.repeatLayout = <RepeatLayoutMetadataBase>p
    }

    @Input()
    value: any

    repeatLayout!: RepeatLayoutMetadataBase

    fieldVisibility: Map<number, Map<string, boolean>> = new Map()


    constructor(private readonly changeDetectorRef: ChangeDetectorRef) { }

    ngOnInit(): void {

        // Create all repeat fieldVisibility //
        let repeat = this.value[this.repeatLayout.fieldName]
        if (repeat && repeat.length > 0) {

            for (let i = 0; i < repeat.length; i++) {
                this.fieldVisibility.set(i, new Map())
            }

            // Check visibility //
            for (let item of this.repeatLayout.items) {
                            
                if (item.type == LayoutTypeMetadata.Row) {

                    for (let rowItem of (<RowLayoutMetadataBase>item).items) {

                        if (rowItem.type == ItemTypeMetadata.CheckBox || rowItem.type == ItemTypeMetadata.MultiCheckBox || rowItem.type == ItemTypeMetadata.Radio || rowItem.type == ItemTypeMetadata.Select) {

                            let itemLogic = <HasShowHideLogic & ItemMetadataBase> rowItem

                            if (ShowHideLogicMetadataBase.hasAnyValue(itemLogic.logicShowHideField) == false) {
                                continue
                            }

                            this.checkFieldVisibility(itemLogic)

                        }

                    }

                }

            }

            this.changeDetectorRef.detectChanges()

        }

    }

    checkFieldVisibility(item: HasShowHideLogic & ItemMetadataBase) {
    
        let repeat = this.value[this.repeatLayout.fieldName]

        if (repeat && repeat.length > 0) {

            for (let i = 0; i < repeat.length; i++) {

                item.logicShowHideField.forEach(l => {

                    if (l.ref == null) {
                        return
                    }

                    let map = this.fieldVisibility.get(i)!

                    let val = repeat[i][item.fieldName]
                    if (item.type == ItemTypeMetadata.MultiCheckBox && val != undefined) {
                        val = val[<string> l.value]
                    }

                    if ((item.type == ItemTypeMetadata.MultiCheckBox && val) || val == l.value) {
                        map.set(l.ref as string, true)
                    } else {
                        map.set(l.ref as string, false)
                    }

                })

            }

        }       

    }

}
